if (!window.ProductInstallmentWidgetsInitialized) {
  window.ProductInstallmentWidgetsInitialized = true;

  (() => {
    const widgets = () => Array.from(document.querySelectorAll('[data-installment-widget]'));

    const formatMoney = (cents) => {
      const normalizedCents = Number(cents || 0);

      if (window.Shopify?.formatMoney) {
        return window.Shopify.formatMoney(normalizedCents);
      }

      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'GBP',
      }).format(normalizedCents / 100);
    };

    const updateWidget = (widget, priceCents) => {
      const priceValue = Number(priceCents || 0);
      if (!priceValue) return;

      const klarnaTarget = widget.querySelector('[data-installment-klarna]');
      const clearpayTarget = widget.querySelector('[data-installment-clearpay]');

      if (klarnaTarget) klarnaTarget.textContent = formatMoney(Math.round(priceValue / 3));
      if (clearpayTarget) clearpayTarget.textContent = formatMoney(Math.round(priceValue / 4));
    };

    const updateAllWidgets = (priceCents, sectionId = null) => {
      widgets().forEach((widget) => {
        if (sectionId && widget.dataset.sectionId !== String(sectionId)) return;
        updateWidget(widget, priceCents);
      });
    };

    const init = () => {
      widgets().forEach((widget) => {
        const productId = Number(widget.dataset.productId);
        const sectionId = widget.dataset.sectionId;

        let initialVariant = null;
        const productInfo = document.querySelector(
          `product-info[data-section="${sectionId}"][data-product-id="${productId}"]`
        );

        if (productInfo?.dataset.productId && String(productInfo.dataset.productId) === String(productId)) {
          const priceElement = productInfo.querySelector('.price-item--regular');
          if (priceElement && priceElement.dataset.price) {
            updateWidget(widget, priceElement.dataset.price);
          }
        }

        if (!initialVariant && window.meta?.product?.variants) {
          initialVariant =
            window.meta.product.variants.find((variant) => variant.id === window.meta.product.selectedVariantId) ||
            window.meta.product.variants[0];
        }

        if (initialVariant?.price) {
          updateWidget(widget, initialVariant.price);
        }
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (!data?.variant?.price) return;
        updateAllWidgets(data.variant.price, data.sectionId);
      });
    }

    document.addEventListener('variant:change', (event) => {
      if (!event.detail?.variant?.price) return;
      updateAllWidgets(event.detail.variant.price);
    });
  })();
}
